import { forwardRef } from "react";

import Icon from "@/components/Icon";
import SchoologySVG from "./SchoologySVG.svg.jsx";

const SchoologyIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={SchoologySVG} {...props} />;
});

export default SchoologyIcon;
